// AMA Guides 5th Edition — Combined Values math.
//
// Single source of truth. This logic was previously duplicated in 7+ places
// (App.tsx, ResultsSummaryBox, HandOverallRatingNarrative, ShoulderRatingCalculator,
// handCalculations) which risked the copies diverging — exactly the kind of bug
// that bit the order-dependent combine. Import from here instead of re-defining.

/**
 * Combine two whole-number impairment percentages via the AMA Combined Values
 * Chart formula: A + B(1 - A), with A = larger, B = smaller. Rounded to a whole
 * percent (the chart is whole-number). Commutative: combine(a, b) === combine(b, a).
 * combine(0, x) === x.
 */
export const combine = (val1: number, val2: number): number => {
  return Math.round(val1 + val2 - (val1 * val2) / 100);
};

/**
 * Combine 3+ impairment values via the AMA Combined Values Chart.
 * Mirrors the reference cvcFold: drops values not above zero, sorts largest-first,
 * rounds the first value, then rounds each next value and combined result.
 * Empty input returns zero.
 */
export const combineAMAValues = (values: number[]): number => {
  const sorted = values.filter((v) => v > 0).sort((a, b) => b - a);
  if (sorted.length === 0) return 0;
  let acc = Math.round(sorted[0]);
  for (let i = 1; i < sorted.length; i++) {
    acc = combine(acc, Math.round(sorted[i]));
  }
  return acc;
};
